import { render, staticRenderFns } from "./OverDues.vue?vue&type=template&id=f11d8e8c"
import script from "./OverDues.vue?vue&type=script&lang=js"
export * from "./OverDues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports